import React, { useEffect, useState } from 'react'
import {useUser} from '../../hook'
import {HeaderPage} from '../../components/Admin'
import {TableUsers} from '../../components/Admin/Users/TableUsers/TableUsers';
import { ModalBasic } from '../../components/common';
import { CircularProgress } from '@mui/material';
import {AddEditUserForm} from '../../components/Admin/Users';



export function UsersAdmin() {

 
  const [title, setTitle] = useState(null)
  const [showModal, setShowModal] = useState(false)
  const [contentModal, setContentModal] = useState(false)
  //Actualizando lista de usuarios al crear uno nuevo
  const [refreshUser, setRefreshUser] = useState(false);

  const {loading, getUsers, users, deleteUser} = useUser();

  const openCloseModal = () => { setShowModal( (prev) => !prev) }

  const onRefreshUser = () => { setRefreshUser( (prev)=> !prev) }

  useEffect(() => {
    getUsers();
  }, [refreshUser]);

  const addUser = () =>{
    setTitle("Nuevo Usuario");
    setContentModal(<AddEditUserForm onRefreshUser={onRefreshUser} onClose={openCloseModal}/>);
    openCloseModal();
  }

  const updateUser = (data) => {
    setTitle("Actualizar Usuario")
    setContentModal(
    <AddEditUserForm 
    onRefreshUser={onRefreshUser} 
    onClose={openCloseModal}
    user={data}
    />);
    openCloseModal();
   
  }


  const onDeleteUser = async(data)=>{
    const result = window.confirm(`¿Eliminar usuario ${data.email}`);

    if(result) {
      try {
        await deleteUser(data.id);
        onRefreshUser();
      } catch (error) {
        console.log(error)
      }
      
    }
  }

  return (
    <div>
      <HeaderPage title="Usuarios" btnClick={addUser}/>

      {(loading === true) ? <CircularProgress /> : 
      <TableUsers 
        users={users}
        updateUser={updateUser}
        onDeleteUser={onDeleteUser}
      /> }
      


      <ModalBasic 
      show={showModal}
      title={title} 
      onClose={openCloseModal}
      children={contentModal}
      />
    </div>
  )
}
